export const locale = {
    lang: 'es',
    data: {
        GASOLINERAS: {
            EDIT: {
                TITLE: 'MODIFICAR GASOLINERA'
            }
        }
    }
};
